export const DEFAULT_LANGUAGE = "en";

export const getByLanguage = <T>(
  field: Record<string, T> | undefined | null,
  language?: string,
): T | undefined => {
  if (!field) return undefined;
  return field[language || DEFAULT_LANGUAGE] ?? field[DEFAULT_LANGUAGE];
};
